import React from "react";
import UserForm from "../components/users/UserForm";
import TitleUpdater from "../components/common/layout/TitleUpdater";

export default function UsersPage() {

  return (
    <div>
      <TitleUpdater />
      <UserForm />
    </div>
  );
}
